// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3G4OU","content":"LayoutSettings_content__1KiPi"};